'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/monthsAfter.js
// module id = 198
// module chunks = 0